import React from 'react'
import moment from 'moment'

import { Avatar, Icon } from '../../../../components/UI'
import UpcomingClassLanguage from '../../Statistic/UpcomingClassLanguage'

import { getAvatarUrl, getUserName } from '../../../../helpers'

import { priceTypes } from '../../../../constants'

const JobPostModalInfo = ({ job }) => {
  const priceType = priceTypes.find((priceType) => job.price_type === priceType.value)

  const languagesContent = job.creator_profile.languages.map((language) => {
    return <UpcomingClassLanguage key={language} language={language} className="!font-bold" />
  })

  return (
    <div className="flex-1 p-[20px] border-[#FFCA84] border-[1px] bg-[#FFF5EE] rounded-[10px] flex flex-col items-start">
      <div className="w-full flex items-center justify-between">
        <div className="flex items-center w-[70%]">
          <Avatar
            src={getAvatarUrl(job.job_creator.profile_picture)}
            gender={job.creator_profile.gender}
            className="mr-[10px] w-[36px] h-[36px]"
          />

          <span className="max-w-[190px] text-primary-100 text-base font-bold text-ellipsis whitespace-nowrap overflow-hidden">
            {getUserName(
              job.job_creator,
              job.creator_profile.display_name,
              job.creator_profile.display_last_name
            )}
          </span>

          <div className="ml-[10px] flex items-center">
            <div aria-hidden className="w-[12px] h-[12px] rounded-full bg-[#1AC057]" />

            <span className="ml-[4px] text-sm font-normal text-primary-100">Online</span>
          </div>
        </div>

        <span className="text-base font-bold text-primary-100">
          $ {job.price}
          {priceType?.value === 'hourly' ? '/hour' : ''}
        </span>
      </div>

      <div className="mt-[20px] w-full flex items-center justify-between">
        <div className="gap-x-[16px] flex items-center">
          <div className="flex justify-center items-center">
            <img
              className="w-[24px] h-[24px]"
              src="/assets/icon/checkbox-multiple-line.svg"
              alt="Checkbox"
            />

            <span className="font-normal ml-1 text-sm text-[#F67443]">{job.checks || 0}</span>
          </div>

          <div className="flex justify-center items-center">
            <img className="w-[24px] h-[24px]" src="/assets/icon/user-green.svg" alt="User" />

            <span className="font-normal ml-1 text-sm text-[#F67443]">{job.users || 0}</span>
          </div>

          <div className="flex justify-center items-center">
            <img className="w-[24x] h-[24px]" src="/assets/icon/star.svg" alt="Star" />

            <span className="font-normal ml-1 text-sm text-[#F67443]">{job.rate || 0}</span>
          </div>

          <div className="flex justify-center items-center">
            <span className="text-[#B733DD] text-sm font-semibold">ROI</span>
            <span className="text-[#F67443] font-medium ml-1 text-xs">{job.roi || 0}%</span>
          </div>
        </div>

        <span className="rounded-[8px] bg-primary-button h-[28px] px-[8px] text-xs text-[#FDFDFD] font-bold flex items-center">
          {priceType?.label} Job
        </span>
      </div>

      <div className="w-full mt-[20px]">
        <h5 className="text-base text-primary-100 font-bold">About Tutor</h5>

        <p className="mt-[8px] text-sm font-normal text-primary-100">{job.description}</p>
      </div>

      <div className="w-full mt-auto flex flex-col items-start gap-y-[16px] pt-[16px]">
        <div className="w-full flex items-center justify-between">
          <div className="flex items-center">
            <Icon name="time-fill" color="#F79009" className="w-[24px] h-[24px] mr-[8px]" />

            <span className="text-base font-bold text-primary-100">Time Posted</span>
          </div>

          <span className="text-base font-bold text-primary-100">
            {moment(job.date_created).from()}
          </span>
        </div>

        {!!job.creator.email && (
          <div className="w-full flex items-center justify-between">
            <div className="flex items-center">
              <Icon name="mail" color="#F79009" className="w-[24px] h-[24px] mr-[8px]" />

              <span className="text-base font-bold text-primary-100">Email</span>
            </div>

            <span className="text-base font-bold text-primary-100">{job.creator.email}</span>
          </div>
        )}

        <div className="w-full flex items-center justify-between">
          <div className="flex items-center w-[65%]">
            <img
              src="/assets/icon/lang.svg"
              alt="Language"
              className="mr-[8px]"
              draggable={false}
            />

            <ul className="flex items-center flex-wrap gap-[4px] flex-1">{languagesContent}</ul>
          </div>

          <div className="flex items-center justify-center gap-x-[24px]">
            <div className="flex items-center justify-center">
              <Icon className="mr-[4px]" name="global-line" color="#F79009" />

              <img className="block" src="/assets/image/America_Flag.svg" alt="us" />
            </div>

            <div className="flex items-center justify-center">
              <Icon className="mr-[4px]" name="home" color="#F79009" />

              <img className="block" src="/assets/image/America_Flag.svg" alt="us" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default JobPostModalInfo
